import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { BodyClassService } from 'src/app/providers/util/BodyClassService';
// import { EventEmitter } from 'protractor';

@Component({
	selector: 'app-footer',
	standalone: false,
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
	@Input() pageSpecificFormObject;
	@Input() webCoCanSubmit: boolean;
	@Output() footerEmitter: EventEmitter<any> = new EventEmitter<any>();

	bottomSheetOpen$: boolean = false;

	isIQACADMIN: boolean = false;
	isWEBEQUI: boolean = false;
	isOFFICE_CO: boolean = false;
	loggedInUserName: any;
	isTEACHER: boolean = false;
	isLibrarian: boolean = false;
	isCriteriaCoordinator: boolean = false;
	profile: any = {};
	subscriptionStatus: boolean = true;
	isDuelRole: boolean = false;
	isFROMIQACDASHBOARD: boolean = false;
	isFROM_CRITERIA_DASHBOARD: boolean = false;
	isFROMPERSONALDASHBOARD: boolean = false;
	// formStatus;
	constructor(
		public userdataService: UserDataService,
		public alertController: AlertController,
		public router: ActivatedRoute,
		private bodyClassService: BodyClassService
	) {}

	async ngOnInit() {
		this.bodyClassService.hasClass('bottom-sheet-open').subscribe((data) => {
			this.bottomSheetOpen$ = data;
		});
		await this.setCurrentSection();
		this.checkLoggedInUserRole();
		this.getProfile();
		this.getUserInfo();
		this.userdataService.getCurrentActiveSection().then((section) => {
			if (section) {
				if (section === 'IQAC_DASHBORAD') {
					this.isFROMIQACDASHBOARD = true;
				} else if (section === 'PERSONAL_DASHBORD') {
					this.isFROMPERSONALDASHBOARD = true;
				} else if (section === 'CRITERIA_DASHBORAD') {
					this.isFROM_CRITERIA_DASHBOARD = true;
				}
			}
		});
	}
	/* ngOnChanges(changes: SimpleChange) {
    for (const pageSpecificFormObject in changes) {
      const updatedValue = changes[pageSpecificFormObject].currentValue;     
      this.pageSpecificFormObject =  updatedValue;
      this.canReplicate();
      this.canReplicateApartFromTeacher();
      this.canShareApartFromTeacher();
    }
  } */

	async setCurrentSection() {
		if (
			this.router.snapshot.paramMap.get('activeSection') != '' &&
			this.router.snapshot.paramMap.get('activeSection') != 'undefined' &&
			this.router.snapshot.paramMap.get('activeSection') != null
		) {
			await this.userdataService.saveCurentSection(this.router.snapshot.paramMap.get('activeSection'));
		}
	}

	checkLoggedInUserRole() {
		this.userdataService.getLoggedInUserRole().then((roles) => {
			console.log(roles);
			if (roles) {
				if (roles.includes('IQAC_ADMIN')) {
					this.isIQACADMIN = true;
				}
				if (roles.includes('WEB_EQUI')) {
					this.isWEBEQUI = true;
				}
				if (roles.includes('OFFICE_EQUI')) {
					this.isOFFICE_CO = true;
				}
				if (roles.includes('TEACHER_EQUI')) {
					this.isTEACHER = true;
				}
				if (roles.includes('LIB_EQUI')) {
					this.isLibrarian = true;
				}
				if (roles.includes('CRITERIA_COORDINATOR')) {
					this.isCriteriaCoordinator = true;
				}
				if (
					(this.isTEACHER && this.isIQACADMIN) ||
					(this.isTEACHER && this.isCriteriaCoordinator) ||
					(this.isTEACHER && this.isOFFICE_CO) ||
					(this.isTEACHER && this.isWEBEQUI)
				) {
					this.isDuelRole = true;
				}
				if (
					(this.isIQACADMIN && this.isOFFICE_CO) ||
					(this.isIQACADMIN && this.isWEBEQUI) ||
					(this.isIQACADMIN && this.isCriteriaCoordinator) ||
					(this.isCriteriaCoordinator && this.isWEBEQUI) ||
					(this.isCriteriaCoordinator && this.isOFFICE_CO) ||
					(this.isOFFICE_CO && this.isWEBEQUI)
				) {
					this.isDuelRole = true;
				}
			}
		});
	}
	getUserInfo() {
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.loggedInUserName = profile.emailId;
			}
		});
	}

	sendFormForApproval() {
		if (this.titleValidationCheck()) {
			this.populateForWithExtraAttributes();
			this.presentSubmitForApprovalFormAlert();
			// this.footerEmitter.emit("sendFormForApproval");
		}
	}
	rejectForm() {
		this.populateForWithExtraAttributes();
		this.footerEmitter.emit('rejectForm');
	}
	forwordForm() {
		this.populateForWithExtraAttributes();
		this.footerEmitter.emit('forwordForm');
	}
	formSharing() {
		this.populateForWithExtraAttributes();
		this.footerEmitter.emit('formSharing');
	}
	recallForm() {
		this.populateForWithExtraAttributes();
		this.presentRecalledFormAlert();
	}
	resentForm() {
		if (this.titleValidationCheck()) {
			this.populateForWithExtraAttributes();
			this.presentResentFormAlert();
			// this.footerEmitter.emit("resentForm");
		}
	}
	replicateForm() {
		this.populateForWithExtraAttributes();
		this.footerEmitter.emit('replicateForm');
	}
	submitForm() {
		if (this.titleValidationCheck()) {
			this.footerEmitter.emit('submitForm');
		}
	}

	async updateForm() {
		if (this.titleValidationCheck()) {
			const alert = await this.alertController.create({
				header: 'Do you want to save form?',
				buttons: [
					{
						text: 'Yes',
						role: 'Ok',
						handler: () => {
							this.populateForWithExtraAttributes();
							this.footerEmitter.emit('updateForm');
						}
					},
					{
						text: 'No',
						role: 'Ok',
						handler: () => {
							console.log('save cancel');
						}
					}
				]
			});
			alert.present();
		}
	}
	approvedForm() {
		this.populateForWithExtraAttributes();
		this.footerEmitter.emit('approvedForm');
	}
	submitForApprovalWebC() {
		this.populateForWithExtraAttributes();
		this.footerEmitter.emit('submitForApprovalWebC');
	}
	deleteForm() {
		this.populateForWithExtraAttributes();
		this.footerEmitter.emit('deleteForm');
	}

	populateForWithExtraAttributes() {
		if (this.pageSpecificFormObject.departmentIds) {
			// THIS IS HACK, Because SAVE API expects DepartmentIDs and update API expects department as attribute name... .so need to copy
			this.pageSpecificFormObject.department = [...this.pageSpecificFormObject.departmentIds];
		}
		if (this.pageSpecificFormObject.committeIds) {
			// THIS IS HACK, Because SAVE API expects committeIds and update API expects committee as attribute name... .so need to copy
			this.pageSpecificFormObject.committee = [...this.pageSpecificFormObject.committeIds];
		}
		if (this.pageSpecificFormObject.inchargeUserIds) {
			this.pageSpecificFormObject.inchargeUser = [...this.pageSpecificFormObject.inchargeUserIds];
		}
		if (this.pageSpecificFormObject.involvedUserIds) {
			this.pageSpecificFormObject.involvedUser = [...this.pageSpecificFormObject.involvedUserIds];
		}
	}

	canSubmit(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			!this.isFROMIQACDASHBOARD &&
			this.loggedInUserName == this.pageSpecificFormObject.createdBy &&
			(formStatus == 'CREATED' || formStatus == 'RECALLED' || formStatus == 'REVERTED' || formStatus == 'RESENT')
		);
	}

	canForward(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			this.isIQACADMIN &&
			this.isFROMIQACDASHBOARD &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE' &&
			formStatus != 'REVERTED' &&
			formStatus != 'SUBMITTED_FOR_APPROVAL' &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_WebC_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_OFFICE_UPDATED'
		);
	}
	canRevert() {
		let formStatus = this.pageSpecificFormObject.status;
		let canIQAC_REVERT = this.isIQACADMIN && this.isFROMIQACDASHBOARD && formStatus != 'REVERTED';
		let canCRITERIA_CO_REVERT =
			this.isCriteriaCoordinator && this.isFROM_CRITERIA_DASHBOARD && formStatus != 'REVERTED';
		return canIQAC_REVERT || canCRITERIA_CO_REVERT;
	}
	canAprove(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		let formStatusNotApproved =
			formStatus != 'APPROVED' &&
			formStatus != 'REVERTED' &&
			formStatus != 'APPROVED_WITH_WebC' &&
			formStatus != 'APPROVED_WITH_OFFICE_CO' &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE' &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' &&
			formStatus != 'APPROVED_WITH_WebC_UPDATED' &&
			formStatus != 'APPROVED_WITH_OFFICE_CO_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_WebC_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_OFFICE_UPDATED';
		let canIQACAPPROVE = this.isIQACADMIN && this.isFROMIQACDASHBOARD && formStatusNotApproved;

		let canCRITERIA_CO_APPROVE = this.isCriteriaCoordinator && this.isFROM_CRITERIA_DASHBOARD && formStatusNotApproved;
		return canIQACAPPROVE || canCRITERIA_CO_APPROVE;
	}
	canUpdate(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			(this.pageSpecificFormObject.id &&
				!this.isFROMIQACDASHBOARD &&
				(formStatus == 'CREATED' ||
					formStatus == 'REVERTED' ||
					(formStatus == 'RECALLED' && this.loggedInUserName == this.pageSpecificFormObject.createdBy))) ||
			(formStatus == 'RESENT' && this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
			(formStatus == 'SHARED' && this.loggedInUserName != this.pageSpecificFormObject.createdBy)
		);
	}
	canSubmitByWebc(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			this.isWEBEQUI &&
			(formStatus == 'SHARED_WITH_WebC' ||
				formStatus === 'SHARED_WITH_WEB_AND_OFFICE' ||
				formStatus === 'APPROVED_WITH_WebC' ||
				formStatus === 'APPROVED_WITH_WEB_AND_OFFICE') &&
			this.webCoCanSubmit
		);
	}
	canReplicate(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			(formStatus === 'APPROVED' ||
				formStatus === 'APPROVED_WITH_WebC' ||
				formStatus === 'APPROVED_WITH_OFFICE_CO' ||
				formStatus === 'APPROVED_WITH_WEB_AND_OFFICE' ||
				formStatus === 'APPROVED_WITH_WebC_UPDATED' ||
				formStatus === 'APPROVED_WITH_OFFICE_CO_UPDATED' ||
				formStatus === 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
				formStatus === 'APPROVED_WITH_BOTH_WebC_UPDATED' ||
				formStatus === 'APPROVED_WITH_BOTH_OFFICE_UPDATED') &&
			this.loggedInUserName == this.pageSpecificFormObject.createdBy
		);
	}
	canCreate(): boolean {
		return this.pageSpecificFormObject.id == null;
	}
	canShare(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			this.isFROMPERSONALDASHBOARD &&
			//!this.isIQACADMIN
			//&& !this.isOFFICE_CO
			//&& (!this.isLibrarian || this.isFROMPERSONALDASHBOARD)
			formStatus != 'APPROVED' &&
			//&& !this.isIQACADMIN
			formStatus != 'SHARED' &&
			formStatus != 'SUBMITTED_FOR_APPROVAL' &&
			this.pageSpecificFormObject.id != null &&
			this.loggedInUserName == this.pageSpecificFormObject.createdBy &&
			formStatus != 'APPROVED_WITH_WebC' &&
			formStatus != 'APPROVED_WITH_OFFICE_CO' &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE' &&
			formStatus != 'APPROVED_WITH_WebC_UPDATED' &&
			formStatus != 'APPROVED_WITH_OFFICE_CO_UPDATED' &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_WebC_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_OFFICE_UPDATED'
		);
	}
	canRecall(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			!this.isIQACADMIN &&
			!this.isIQACADMIN &&
			formStatus == 'SHARED' &&
			this.pageSpecificFormObject.id != null &&
			this.loggedInUserName == this.pageSpecificFormObject.createdBy
		);
	}

	canResent(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			!this.isIQACADMIN &&
			formStatus == 'SHARED' &&
			this.pageSpecificFormObject.id != null &&
			this.loggedInUserName != this.pageSpecificFormObject.createdBy
		);
	}

	canDeleteForm(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			this.pageSpecificFormObject.createdBy == this.loggedInUserName &&
			(formStatus === 'CREATED' || formStatus === 'RECALLED' || formStatus === 'REVERTED' || formStatus === 'RESENT') &&
			!this.isFROMIQACDASHBOARD
		);
	}
	// ===================================DUEL_ROLE=============================================================
	canSubmitApartFromTeacher(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			this.loggedInUserName == this.pageSpecificFormObject.createdBy &&
			!this.isFROMIQACDASHBOARD &&
			(formStatus == 'CREATED' || formStatus == 'RECALLED' || formStatus == 'REVERTED' || formStatus == 'RESENT')
		);
	}

	canUpdateApartFromTeacher(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			(this.pageSpecificFormObject.id &&
				!this.isFROMIQACDASHBOARD &&
				(formStatus == 'CREATED' ||
					(formStatus == 'REVERTED' && this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
					(formStatus == 'RECALLED' && this.loggedInUserName == this.pageSpecificFormObject.createdBy))) ||
			(formStatus == 'RESENT' && this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
			(formStatus == 'SHARED' && this.loggedInUserName != this.pageSpecificFormObject.createdBy)
		);
	}

	canReplicateApartFromTeacher(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		let statuscheck =
			formStatus === 'APPROVED' ||
			formStatus === 'APPROVED_WITH_WebC' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE' ||
			formStatus === 'APPROVED_WITH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO_UPDATED' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
			formStatus === 'APPROVED_WITH_BOTH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_BOTH_OFFICE_UPDATED';
		let result = statuscheck && this.loggedInUserName == this.pageSpecificFormObject.createdBy;
		return result;
	}
	canCreateApartFromTeacher(): boolean {
		return this.pageSpecificFormObject.id == null;
	}
	canShareApartFromTeacher(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			formStatus != 'APPROVED' &&
			formStatus != 'SHARED' &&
			formStatus != 'SUBMITTED_FOR_APPROVAL' &&
			this.pageSpecificFormObject.id != null &&
			formStatus != 'APPROVED_WITH_WebC' &&
			formStatus != 'APPROVED_WITH_OFFICE_CO' &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE' &&
			formStatus != 'SHARED_WITH_OFFICE_CO' &&
			formStatus != 'SHARED_WITH_WebC' &&
			formStatus != 'SHARED_WITH_WEB_AND_OFFICE' &&
			formStatus != 'APPROVED_WITH_WebC_UPDATED' &&
			formStatus != 'APPROVED_WITH_OFFICE_CO_UPDATED' &&
			formStatus != 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_WebC_UPDATED' &&
			formStatus != 'APPROVED_WITH_BOTH_OFFICE_UPDATED' &&
			this.loggedInUserName == this.pageSpecificFormObject.createdBy &&
			this.isFROMPERSONALDASHBOARD
		);
	}
	canRecallApartFromTeacher(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			formStatus == 'SHARED' &&
			!this.isFROMIQACDASHBOARD &&
			this.pageSpecificFormObject.id != null &&
			this.loggedInUserName == this.pageSpecificFormObject.createdBy
		);
	}

	canResentApartFromTeacher(): boolean {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			formStatus == 'SHARED' &&
			!this.isFROMIQACDASHBOARD &&
			this.pageSpecificFormObject.id != null &&
			this.loggedInUserName != this.pageSpecificFormObject.createdBy
		);
	}
	canRevertApartFromTeacher() {
		let formStatus = this.pageSpecificFormObject.status;
		let formStatusForReverted =
			formStatus === 'SUBMITTED_FOR_APPROVAL' ||
			formStatus === 'APPROVED' ||
			formStatus === 'APPROVED_WITH_WebC' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO' ||
			formStatus === 'APPROVED_WITH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_OFFICE_CO_UPDATED' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
			formStatus === 'SHARED_WITH_WEB_AND_OFFICE' ||
			formStatus === 'SHARED_WITH_WebC' ||
			formStatus === 'SHARED_WITH_OFFICE_CO' ||
			formStatus === 'APPROVED_WITH_BOTH_WebC_UPDATED' ||
			formStatus === 'APPROVED_WITH_BOTH_OFFICE_UPDATED' ||
			formStatus === 'APPROVED_WITH_WEB_AND_OFFICE';
		let canIQAC_REVERT = this.isIQACADMIN && this.isFROMIQACDASHBOARD && formStatusForReverted;

		let canCRITERIA_CO_REVERT = this.isCriteriaCoordinator && this.isFROM_CRITERIA_DASHBOARD && formStatusForReverted;
		return canIQAC_REVERT || canCRITERIA_CO_REVERT;
	}

	canAproveApartFromTeacher() {
		let formStatus = this.pageSpecificFormObject.status;
		let formStatusForApproval =
			(formStatus === 'SUBMITTED_FOR_APPROVAL' ||
				formStatus === 'SHARED_WITH_WEB_AND_OFFICE' ||
				formStatus === 'SHARED_WITH_WebC' ||
				formStatus === 'SHARED_WITH_OFFICE_CO') &&
			(formStatus != 'APPROVED' ||
				formStatus != 'APPROVED_WITH_WebC' ||
				formStatus != 'APPROVED_WITH_OFFICE_CO' ||
				formStatus != 'APPROVED_WITH_WEB_AND_OFFICE' ||
				formStatus != 'APPROVED_WITH_WebC_UPDATED' ||
				formStatus != 'APPROVED_WITH_OFFICE_CO_UPDATED' ||
				formStatus != 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
				formStatus != 'APPROVED_WITH_BOTH_WebC_UPDATED' ||
				formStatus != 'APPROVED_WITH_BOTH_OFFICE_UPDATED');
		let canIQACAPPROVE = this.isIQACADMIN && this.isFROMIQACDASHBOARD && formStatusForApproval;

		let canCRITERIA_CO_APPROVE = this.isCriteriaCoordinator && this.isFROM_CRITERIA_DASHBOARD && formStatusForApproval;
		return canIQACAPPROVE || canCRITERIA_CO_APPROVE;
	}

	canForwardApartFromTeacher() {
		let formStatus = this.pageSpecificFormObject.status;
		return (
			this.isIQACADMIN &&
			this.isFROMIQACDASHBOARD &&
			(formStatus === 'SHARED_WITH_WebC' ||
				formStatus === 'SHARED_WITH_OFFICE_CO' ||
				formStatus === 'APPROVED' ||
				formStatus === 'APPROVED_WITH_WebC' ||
				formStatus === 'APPROVED_WITH_WebC_UPDATED' ||
				formStatus === 'APPROVED_WITH_OFFICE_CO' ||
				formStatus === 'APPROVED_WITH_OFFICE_CO_UPDATED') &&
			(formStatus != 'SHARED_WITH_WEB_AND_OFFICE' ||
				formStatus != 'APPROVED_WITH_WEB_AND_OFFICE' ||
				formStatus != 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
				formStatus != 'REVERTED' ||
				formStatus != 'SUBMITTED_FOR_APPROVAL' ||
				formStatus != 'APPROVED_WITH_BOTH_WebC_UPDATED' ||
				formStatus != 'APPROVED_WITH_BOTH_OFFICE_UPDATED')
		);
	}

	async presentRecalledFormAlert() {
		const alert = await this.alertController.create({
			header: 'Recall form',
			// subHeader: staffName,
			inputs: [
				{
					name: 'recalledMessage',
					type: 'textarea',
					placeholder: 'Type your message here'
				}
			],
			buttons: [
				{
					text: 'Recall',
					role: 'Ok',
					handler: (data: any) => {
						if (data.recalledMessage != '') {
							// this.recallForm(data);
							this.footerEmitter.emit('recallForm');
							this.pageSpecificFormObject.rejectionMessage = data.recalledMessage;
						} else {
							this.userdataService.presentToast('Please add your message', 'warning');
						}
					}
				},
				{
					text: 'Cancel',
					role: 'Cancel',
					handler: () => {
						console.log('cancel click');
					}
				}
			]
		});
		alert.present();
	}

	async presentSubmitForApprovalFormAlert() {
		const alert = await this.alertController.create({
			header: 'Submit form for approval',
			// subHeader: staffName,
			inputs: [
				{
					name: 'submitMessage',
					type: 'textarea',
					placeholder: 'Type your message here'
				}
			],
			buttons: [
				{
					text: 'Submit',
					role: 'Ok',
					handler: (data: any) => {
						if (data.submitMessage != '' && data.submitMessage.trim() != 0) {
							// this.sendFormForApproval(data);
							this.pageSpecificFormObject.rejectionMessage = data.submitMessage;
							this.footerEmitter.emit('sendFormForApproval');
						} else {
							this.userdataService.presentToast('Please add your message', 'warning');
						}
					}
				},
				{
					text: 'Cancel',
					role: 'Cancel',
					handler: () => {
						console.log('cancel click');
					}
				}
			]
		});
		alert.present();
	}

	async presentResentFormAlert() {
		const alert = await this.alertController.create({
			header: 'Return form',
			// subHeader: staffName,
			inputs: [
				{
					name: 'resentMessage',
					type: 'textarea',
					placeholder: 'Type your message here'
				}
			],
			buttons: [
				{
					text: 'Return',
					role: 'Ok',
					handler: (data) => {
						if (data.resentMessage != '' && data.resentMessage.trim() != 0) {
							// this.resentForm(data);
							this.footerEmitter.emit('resentForm');
							this.pageSpecificFormObject.rejectionMessage = data.resentMessage;
						} else {
							this.userdataService.presentToast('Please add your message', 'warning');
						}
					}
				},
				{
					text: 'Cancel',
					role: 'Cancel',
					handler: () => {
						console.log('cancel click');
					}
				}
			]
		});
		alert.present();
	}

	getProfile() {
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.profile = profile;
				if (this.profile.college.status == 'SUBS_EXPIRED') {
					this.subscriptionStatus = false;
				}
				console.log('College status:', this.profile.college.status);
				console.log('subscriptionStatus:', this.subscriptionStatus);
			}
		});
	}

	titleValidationCheck() {
		let titleCheck = true;
		if (this.pageSpecificFormObject.title === undefined) {
			this.userdataService.presentToast('Please Enter Title', 'danger');
			titleCheck = false;
		} else if (this.pageSpecificFormObject.title.trim().length === 0) {
			this.userdataService.presentToast('Please Enter Title', 'danger');
			titleCheck = false;
		}
		return titleCheck;
	}
}
